import { DIRECTORY_SKELETON_IDS } from '@/features/user-management/config/directory';
import { Skeleton } from '@/shared/components/ui/skeleton';

export function RoleDirectoryPendingState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-background" aria-busy="true">
      <header className="shrink-0 border-b px-4 py-3 sm:px-6">
        <div className="flex items-end gap-3">
          <div className="space-y-2">
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-3 w-72 max-w-full" />
          </div>
          <Skeleton className="ml-auto h-8 w-32" />
        </div>
        <Skeleton className="mt-3 h-9 w-full max-w-md" />
      </header>

      <div className="min-h-0 flex-1 space-y-3 overflow-hidden p-4 sm:p-6">
        {DIRECTORY_SKELETON_IDS.map((skeletonId) => (
          <Skeleton key={skeletonId} className="h-[72px] w-full" />
        ))}
      </div>
    </div>
  );
}
